import React, { Component } from 'react';
import{ LinkBox, TopLine } from './lib';
import './layout.css';
import './buttons.css';
import './colors.css';

const topLineButtons = {
  className:"Gray",
  links:[
    {text:"WynChar", href:"https://wynchar.com/"},
    {text:"Wynette", href:"https://thenette.com"},
    {text:"Charlie"},
  ],
};
const recent = {
  title:"Working",
  className:"Wheat",
  links:[
    {href:"pilgrims", text:"pilgrims"},
    {href:"pilgrimsPrev", text:"pilgrims (previous)"},
    {href:"pilgrimsApp", text:"pilgrims App"},
    {href:"jeopardy", text:"jeopardy"},
    {href:"jeopardyPrev", text:"jeopardy (previous)"},
    {href:"jeopardyApp", text:"jeopardy App"},
    {href:"jeopardyStats", text:"jeopardy Stats"},
  ],
};
const links = {
  title:"Links",
  className:"WhiteSmoke",
  links:[
    {href:"https://crowley.pw/mbg", text:"Men's Book Group"},
    {href:"https://wynchar.com/wcblogs", text:"All Our Travel Blogs"},
    {href:"https://thenette.com/recipes", text:"Recipes"},
    {href:"https://wynchar.com/Photos/MildredsPhotos", text:"MildredsPhotos"},
    {href:"./beats2.html", text:"Beats per minute"},
    {href:"./levels/levels.html", text:"levels/levels.html"},
    {href:"./trips/Complexity", text:"Complexity"},
  ],
};
const photoAlbums = {
  title:"Photo Albums",
  className: "Moccasin",
  links:[
    {href:"https://wynchar.com/photos2", text:"Other Photo Albums"},
  ],
};
const blogs = {
  title: "Blogs",
  className: "Linen",
  links: [
    {href: "https://wynchar.com/wcblogs", text: "All blogs (fast)"},
    {href: "https://wynchar.com/cnblog", text: "2018 Camino del Norte"},
    {href: "https://wynchar.com/i17", text: "2017 Via Francigena"},
    {href: "https://wynchar.com/c16", text: "2016 Camino Portuguese"},
    {href: "https://wynchar.com/s15", text: "2015 Sevilla"},
    {href: "https://wynchar.com/c14", text: "2014 Camino Frances"},
    {href: "https://wynchar.com/c13", text: "2013 Camino Frances"},
    {href: "https://wynchar.com/s12", text: "2012 Spain"},
    {href: "https://wynchar.com/i11", text: "2011 Italy"},
    {href: "https://britain2009.wordpress.com/", text: "2009 England"},
    {href: "https://wyncharitaly08.wordpress.com/", text: "2008 Italy"},
    {href: "https://wynchar06.blogspot.com", text: "2006 Slovenia/Croatia"},
    {href: "https://wynchar.com/wcblogs/i04.html", text: "2004 Italy"},
    {href: "https://thenette.com/italy2002.html", text: "2002 Italy"},
    {href: "https://wynchar.com/wcblogs/s02.html", text: "2002 Spain"},
    {href: "https://thenette.com/italy2000.html", text: "2000 Italy"},
  ],
};
const caminoMaps = {
  title:"Camino Maps",
  className:"Linen",
  links:[
    {text:"2018 Norte", href:"https://drive.google.com/open?id=13i5RWXCGT_Rd9iLVzgjLAyPLSyu1JJtB&usp=sharing"},
    {text:"2019 Norte plan", href:"https://drive.google.com/open?id=1a0_Mb25BYzbMwSl8tTt8_uneNFPpBeeB&usp=sharing"},
    {text: "All our caminos", href: "https://drive.google.com/open?id=1vlCphD1-CqUKGZMcJ5WxRmtwdRP0GRe0&usp=sharing"},
    {text:"Camino del Norte", href:"https://drive.google.com/open?id=1w0Wzq8HLgKCVVc8ht1x85M9TcPSfnKQ0&usp=sharing"},
    {text:"Camino Frances", href:"https://drive.google.com/open?id=1cwvG2iZKxUGq8yzVjprYp7C3FAtw_VrH&usp=sharing"},
    {text:"Camino Finisterre", href:"https://drive.google.com/open?id=14Ws-voHUgIXmEWV_LXsjGE2CRnvaFQiT&usp=sharing"},
  ],
};


const boxes = [recent, links, blogs, caminoMaps];

class App extends Component {
  render() {
    return (
      <div className="main-content">
        <TopLine box={topLineButtons} />
        <div className="flex-div">
          {boxes.map((box,ibox) => (
            <LinkBox key={ibox} box={box} />
          ))}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js